import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight, ShieldCheck, HeartPulse, Sparkles, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CLINIC_PHONE } from "@/lib/mailto";

export function HeroWarm() {
    const { t } = useTranslation();
    return (
        <section data-testid="home-hero" className="relative overflow-hidden">
            <div className="absolute inset-0 hero-mist pointer-events-none" />
            <div className="container-page relative pt-14 pb-20 lg:pt-20 lg:pb-28">
                <div className="fade-up">
                    <h1
                        className="font-display text-5xl sm:text-6xl lg:text-8xl font-semibold tracking-[-0.02em] text-[color:var(--brand-navy)] leading-[1.02]"
                        data-testid="hero-brand-title"
                    >
                        {t("hero.brandLine1")}{" "}
                        <span className="text-[color:var(--brand-teal-2)]">{t("hero.brandLine2")}</span>
                    </h1>
                    <p
                        className="mt-8 text-xl sm:text-2xl lg:text-3xl text-[color:var(--brand-navy)] font-medium leading-snug"
                        data-testid="hero-tagline"
                    >
                        {t("hero.tagline")}
                    </p>
                    <p className="mt-6 text-lg sm:text-xl text-[color:var(--text-muted)] leading-relaxed max-w-4xl">
                        {t("hero.description")}
                    </p>

                    <ul className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-3">
                        {[
                            { icon: ShieldCheck, text: t("hero.trustRoyalCollege") },
                            { icon: HeartPulse, text: t("hero.trustDiagnostics") },
                            { icon: Sparkles, text: t("hero.trustApproach") },
                        ].map(({ icon: Icon, text }) => (
                            <li
                                key={text}
                                className="flex items-center gap-2.5 rounded-2xl border border-[color:var(--border-default)] bg-white/60 backdrop-blur-sm px-4 py-3 text-sm sm:text-base font-medium text-[color:var(--brand-navy)]"
                            >
                                <Icon className="h-5 w-5 text-[color:var(--brand-teal-2)]" />
                                <span>{text}</span>
                            </li>
                        ))}
                    </ul>

                    <div className="mt-10 flex flex-col sm:flex-row gap-3">
                        <Button asChild size="lg" data-testid="hero-cta-phone">
                            <a
                                href={`tel:${CLINIC_PHONE.replace(/[^\d+]/g, "")}`}
                                className="gap-1.5"
                            >
                                <Phone className="h-4 w-4" />
                                {t("cta.call")} {CLINIC_PHONE}
                            </a>
                        </Button>
                        <Button
                            asChild
                            variant="outline"
                            size="lg"
                            data-testid="hero-cta-services"
                        >
                            <Link to="/services" className="gap-1.5">
                                {t("cta.learnServices")}
                                <ArrowRight className="h-4 w-4" />
                            </Link>
                        </Button>
                    </div>
                </div>
            </div>
        </section>
    );
}
